import { createSlice } from "@reduxjs/toolkit";

const initialState: IManufacturerNameState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const manufacturerNameSlice = createSlice({
  name: "manufacturerName",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceManufacturerName: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addManufacturerName: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateManufacturerName: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.Details = data;
    },
    deleteManufacturerName: (state, action) => {
      const manufacturerNameToRemove: IManufacturerName = action.payload.data;
      const newManufacturerNameData =
        state.data &&
        state.data.filter((manufacturerName: IManufacturerName) => {
          return manufacturerName.id !== manufacturerNameToRemove.id;
        });
      state.data = newManufacturerNameData;
      state.totalCount = state.totalCount - 1;
    },
    setManufacturerNameDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const manufacturerNameActions = manufacturerNameSlice.actions;
export default manufacturerNameSlice.reducer;